<template>
  <RevCard class="p-24">
    <div class="heading-2 mb-24 flex items-center gap-8">
      <IconGrowth />
      {{ i18n(translations.opportunities) }}
    </div>

    <div class="flex flex-col gap-48 lg:flex-row">
      <!-- Sale opportunities -->
      <SalesOpportunitiesCard class="flex-1" />

      <!-- Trade-in opportunities -->
      <TradeinOpportunitiesCard class="flex-1" />
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconGrowth } from '@ds/icons/IconGrowth'

import translations from './Opportunities.translations'
import SalesOpportunitiesCard from './components/SalesOpportunitiesCard.vue'
import TradeinOpportunitiesCard from './components/TradeinOpportunitiesCard.vue'

const i18n = useI18n()
</script>
()
